import React from 'react';

import { Box, Header, Text } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { primitive } from 'styles/constants/primitives';

const Wrapper = Box.withConfig({
  marginTop: '$2',
  _text: {
    margin: 0,
    color: Styles.color.grey.one,
  },
  accessible: true,
});

const Title = Header.withConfig({
  variant: 'headerTwo',
  paddingTop: '$1.5',
  marginBottom: '$0',
  color: primitive.bk.$bbqBrown,
  fontSize: 'sm',
});

const CancellationPolicyText = Text.withConfig({
  color: primitive.bk.$bbqBrown,
  fontSize: 'sm',
});

export const DeliveryCancellationRedesign = () => {
  const { formatMessage } = useIntl();
  const isEnabled = useFlag(LaunchDarklyFlag.ENABLE_DELIVERY_CANCELLATION_POLICY);
  if (!isEnabled) {
    return null;
  }
  return (
    <Wrapper>
      <Title>{formatMessage({ id: 'cancellationPolicyTitle' })}</Title>
      <CancellationPolicyText>{formatMessage({ id: 'cancellationPolicy' })}</CancellationPolicyText>
    </Wrapper>
  );
};
